<!-- 表二列表 -->

<template>
  <div class="ListCage table8">
    <div class="tabTtl">
      <span>表 1-8：人员基本情况登记表</span>
      <div class="tabBtns">
        <el-button type="primary" @click="memberEdit(1)" size="mini">添加</el-button>
        <a :href="excelModeUrl" download><el-button size="mini">下载模板</el-button></a>
        <el-button @click="ExHandle" type="primary" class="excelRead" size="mini">导入Excel</el-button>
        <el-button @click="goBack" size="mini">返回</el-button>
        <!-- <ExcelIn ref="ExcelSet" @t-frash="goFresh" @excel-errors="errorCtrls" :pressType="pressType" :pressId="pressId"  excelCode="208" /> -->
        <ExcelIn ref="ExcelSet" @t-frash="goFresh" @excel-errors="errorCtrls" :pressType="pressType" excelCode="208" />
      </div>
    </div>
    <div class="tip-div">
      <span class="tip-red"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
    </div>
    <div class="ctrlsLine">
      <el-radio-group v-model="seekPms.type" @change="tabSeek">
        <el-radio :label="0">全部</el-radio>
        <el-radio :label="1">主要负责人</el-radio>
        <el-radio :label="2">其他负责人</el-radio>
        <el-radio :label="3">编辑人员</el-radio>
      </el-radio-group>
      <el-input
        v-model="seekPms.keyword"
        placeholder="通过姓名，身份证号（军官证号），手机号查询"
        size="small"></el-input>
      <!-- <el-button class="seekBtn" @click="tabSeek('init')" size="small">查询</el-button> -->
      <el-button class="dangerBtns" size="small" @click="memberDet(1)" type="warning">删除</el-button>
      <el-button class="dangerBtns" @click="memberClean" size="small" type="danger">清除全部</el-button>

      <div class="tips">
        注：1、持有岗位培训合格证书、持有出版专业职业资格证书，需要上传对应证书图片才能提交到上级，点击“编辑”按钮可以上传对应图片。
        <br />
        <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
        2、请在编辑人员中填写<span v-if="pressType == 1">音像业务</span
        ><span v-else-if="pressType == 2">电子业务</span>全部编辑人员。
        <br />
        <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
        3、编辑人员表中不能重复填写负责人信息。
      </div>
    </div>

    <div class="tabForms">
      <!-- :data="filterData(tabDat, seekStore.where).slice((currentPage - 1) * pageSize, currentPage * pageSize)" -->
      <!-- <el-table :data="filterData(tabDat, seekPms).slice((currentPage - 1) * pageSize, currentPage * pageSize)" border style="width: 100%" v-loading="loading"> -->
      <el-table
        :data="filterData(tabDat, seekPms).slice((currentPage - 1) * pageSize, currentPage * pageSize)"
        border
        style="width: 100%"
        @selection-change="selectionChange"
        v-loading="loading">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 + 15*(seekPms.no - 1) }} -->
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="fullName" label="姓名" width="120" align="center"> </el-table-column>
        <el-table-column label="性别" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.row.gender | translate("C017", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column prop="idNumber" label="身份证号（军官证号）" width="270" align="center"> </el-table-column>
        <el-table-column prop="job" label="职务" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.job | translate("C022", dicMap, scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="政治面貌" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.politicalStatus | translate("C006", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="文化程度" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.culture | translate("C005", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column prop="major" label="专业" width="90" align="center"> </el-table-column>
        <el-table-column label="职称系列" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.professionalTitleSeries | translate("C007", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="职称级别" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.titleLevel | translate("C008", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="入职时间" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.rzDate | stringTrans("time") }}
          </template>
        </el-table-column>
        <el-table-column label="离职时间" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.lzDate | stringTrans("time") }}
          </template>
        </el-table-column>
        <el-table-column label="取得证书时间" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.trainCertificateDate | stringTrans("time") }}
          </template>
        </el-table-column>
        <el-table-column label="是否持有岗位培训资格证书" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type != 3" class="imgIcon" @click="urlCreate('open', scope.row.trainCertificateId)">
              {{ scope.row.isTrainCertificate | translate("C018", dicMap) }}
              <i v-if="scope.row.trainCertificateId" class="el-icon-picture"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="持有出版专业职业资格证书情况" align="center">
          <template slot-scope="scope">
            <span class="imgIcon" @click="urlCreate('open', scope.row.professionalCertificateId)">
              {{ scope.row.certificateSituation | translate("C009", dicMap) }}
              <i v-if="scope.row.professionalCertificateId" class="el-icon-picture"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="cellphone" label="手机号" align="center"> </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="memberEdit(2, scope.row)" size="mini">编辑</el-button>
            <el-button type="danger" @click="memberDet(2, scope.row)" size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        background
        layout="total, prev, pager, next"
        :total="tabDat.length"
        :page-size="pageSize"
        :page-sizes="sizesArray" />
    </div>
    <div class="headBar">
      <span>申报人信息</span>
    </div>
    <div class="editArea newEditArea">
      <div class="editBox">
        <p class="edName">申报人：</p>
        <div class="edInp">
          <el-input size="small" v-model="declare.personnel" placeholder="请输入申报人"></el-input>
        </div>
      </div>
      <div class="editBox">
        <p class="edName">联系方式：</p>
        <div class="edInp">
          <el-input size="small" v-model="declare.contact" placeholder="请输入申报人联系方式"></el-input>
        </div>
      </div>
      <div class="editBox">
        <p class="edName">申报时间：</p>
        <div class="edInp">
          <el-input size="small" v-model="updatedAt" :disabled="true"></el-input>
        </div>
      </div>
      <div class="saveBtn">
        <el-button size="small" @click="goBack">返回</el-button>
        <el-button v-if="pubStatus == 0" type="primary" size="small" @click="postDeclareFun">保存</el-button>
      </div>
    </div>
    <div class="pageArea">
      <!-- <el-pagination
        v-if="allPage > 1"
        layout="prev, pager, next"
        @current-change="goPage"
        :current-page="seekPms.no"
                                :page-count="allPage">
                              </el-pagination> -->
    </div>

    <ExError ref="chinldError" :errorList="excelEr" pressCode="208"></ExError>

    <el-dialog class="pressComDiag" title="" :visible.sync="dialogVisible" @close="urlCreate('close')">
      <div class="imgCont">
        <img :src="imgShowUrl" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import initPagin from "@/mixins/initPagin";
import _ from "lodash";
import { tabList8, tab8Remove, tab8Clean, dicSeek, submitDeclare } from "@/api/pressRole/pressRole";
import { getPfileUrl } from "@/api/pressRole/pressRole";
import ExcelIn from "@/views/components/excelRead/excel";
import ExError from "@/views/components/excelRead/excelError";
export default {
  mixins: [initPagin],
  components: {
    ExcelIn,
    ExError,
  },

  data() {
    return {
      loading: false,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      fileToken: "",
      seekPms: {
        type: 0,
        keyword: "",
        no: 1,
        size: 15,
      },
      allPage: 0,

      excelModeUrl: "",
      pressType: "",
      excelEr: "",
      // 图片查看
      dialogVisible: false,
      imgShowUrl: "",
      declare: {
        personnel: "",
        contact: "",
      },
      updatedAt: "",
      pubStatus: 0,
    };
  },
  filters: {
    translate: function (dat, code, transMap, rowDat) {
      if (code == "C022" && transMap[code][dat] == "其他") {
        return rowDat.professionalOther;
      } else {
        return transMap[code][dat];
      }
    },
    stringTrans: function (dat, code) {
      if (code == "time" && dat && dat.length > 10) {
        return dat.substr(0, 10);
      } else if (code == "time" && dat && dat.length <= 10) {
        return dat;
      }
    },
  },
  methods: {
    tabSeek: function (type) {
      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      tabList8(this.seekPms).then((response) => {
        console.debug("tabList8: ", response);
        let vm = this;
        setTimeout(function () {
          vm.loading = false;
          vm.tabDat = response.pworkerList;
          vm.allPage = response.totalPages;
          vm.allPage = 1;
        }, 300);
        this.declare.contact = response.pOrganizationPersonnel.contact;
        this.declare.personnel = response.pOrganizationPersonnel.personnel;
        this.updatedAt = response.pOrganizationPersonnel.updatedAt;
      });
    },
    memberDet: function (deteMode, dat) {
      let params = {};
      let vm = this;

      function goRemove(postDat) {
        postDat.publishMaterialId = vm.$route.query.mtId;
        tab8Remove(postDat).then(() => {
          vm.tabSeek();
        });
      }

      if (deteMode == 1) {
        if (this.detArrs.length > 0) {
          this.$confirm("确定删除所有选中项吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            params.ids = this.detArrs;
            goRemove(params);
          });
        } else {
          this.$message.error("请勾选所需要删除的项");
        }
      } else if (deteMode == 2) {
        this.$confirm("确定删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          params.ids = [dat.id];
          goRemove(params);
        });
      }
    },
    memberClean: function () {
      this.$confirm("此操作会删除所有人员信息，确定全部清除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          tab8Clean({
            type: this.$route.query.pressType,
            publishMaterialId: this.$route.query.mtId,
          }).then((response) => {
            this.seekPms.type = 0;
            this.keyword = "";
            this.no = 1;
            this.tabSeek();
          });
        })
        .catch(() => {});
    },

    selectionChange: function (selection) {
      let newArr = [];
      for (let i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function () {
      console.debug("dictInit: ");
      let nameArr = ["C017", "C018", "C022", "C006", "C005", "C007", "C008", "C009"];
      let newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "map",
      });
      newPromise.then((result) => {
        this.dicMap = result;
        this.tabSeek();
      });
    },
    memberEdit: function (type, dat) {
      let pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType,
        pgress: type,
        pubStatus: this.pubStatus,
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: "edit_tab8",
        query: pathParams,
      });
    },

    urlCreate: function (mode, id) {
      if (mode == "open") {
        //  this.imgShowUrl = process.env.BASE_API + '/File/File/view/token/' + this.$store.getters.fileToken + '/id/' + id;
        getPfileUrl({ id }).then((response) => {
          this.imgShowUrl = response.payload.url;
        });
        this.dialogVisible = true;
      } else if (mode == "close") {
        this.imgShowUrl = "";
      }
    },

    ExHandle: function () {
      this.$refs.ExcelSet.handleUpload();
    },

    errorCtrls: function (val) {
      this.excelEr = val;
      this.$refs.chinldError.handErrors();
    },

    goPage: function (inx) {
      this.seekPms.no = inx;
      this.tabSeek();
    },

    goFresh: function () {
      this.tabSeek("init");
    },

    goBack: function () {
      this.$router.go(-1);
    },
    /*
     *提交申报人信息
     * */
    postDeclareFun: function () {
      if (!this.declare.personnel) {
        this.$message.error("申报人姓名必填");
        return;
      }
      // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
      //   this.$message.error('申报人手机号格式错误');
      //   return
      // }
      if (!this.declare.contact) {
        this.$message.error("申报人联系方式必填");
        return;
      }
      submitDeclare({
        code: "208",
        publishMaterialId: this.$route.query.mtId,
        organizationPersonnel: this.declare,
      })
        .then((response) => {
          console.log("response=", JSON.stringify(response));
          let tipCode = response.payload.code;
          let tipMessage = response.payload.message;

          if (tipCode == -1) {
            this.$message.error(`${tipMessage}`);
          } else {
            this.$message({
              message: "保存成功！",
              type: "success",
            });
            this.goBack();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    filterData: function (data, params) {
      console.debug("filterData: ", params.type, params.keyword);
      let text = params.keyword;
      // if (!text || text.trim() === '') return data
      text = text.toLowerCase();
      return _.filter(data, (x) => {
        // if (params.type !=0 && x.type != params.type) return false
        return (
          ((x.fullName && x.fullName.includes(text)) ||
            (x.idNumber && x.idNumber.includes(text)) ||
            (x.cellphone && x.cellphone.includes(text))) &&
          (params.type == 0 || x.type == params.type)
        );
      });
    },
  },
  created: function () {
    console.debug("created: ", this.$route.query);
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.pressType = this.$route.query.pressType;
    this.dictInit();
    // this.excelModeUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=208&token=' + encodeURIComponent(this.$store.getters.fileToken);
    this.excelModeUrl = process.env.URL_FILE + "/drmb/208_404.xlsx";
    // this.excelModeUrl = process.env.BASE_API + '/drmb/208_404.xlsx';
    this.pubStatus = this.$route.query.pubStatus;
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleL";

.table8 {
  .importBtn {
    width: auto !important;
    padding: 7px 15px;
  }

  .saveBtn {
    margin: 30px 200px;

    .el-button {
      width: 150px;
      margin-right: 10px;
    }
  }

  .el-button + .el-button {
    margin-left: 0px;
  }

  .pageArea {
    text-align: center;
    padding: 30px 0px;
  }

  .imgIcon {
    cursor: pointer;
  }

  // .imgCont{
  //     max-height: 480px;
  //     overflow-y: scroll;
  //     text-align: center;
  // }

  .imgCont img {
    width: 100%;
  }

  .ctrlsLine {
    padding: 12px;

    .excelRead {
      float: right;
    }

    .el-radio__label {
      margin-left: -5px;
    }

    .el-input {
      display: inline-block;
      width: 360px;
      margin-left: 20px;

      input {
        border-radius: 0;
      }
    }

    .el-icon-picture {
      cursor: pointer !important;
    }

    .el-button + .el-button {
      margin-left: 0;
    }

    .el-radio + .el-radio {
      margin-left: 20px;
    }

    .seekBtn {
      margin-right: 20px;
    }

    .tips {
      font-size: 12px;
      margin-top: 12px;
      color: salmon;
      line-height: 22px;
    }
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;
    margin-top: 12px;
  }

  .newEditArea {
    width: 80%;
    margin: 0 auto;
    padding: 30px;

    .editBox {
      width: 100%;
      height: auto;
      overflow: hidden;

      p {
        float: left;
        width: 100px;
        text-align: right;
      }

      .edInp {
        width: 300px;
        float: left;
        margin: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// table8.vue?23af3b36